var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"admin-layout-wrap"},[_c('div',{staticClass:"admin-layout-left"},[_c('AdminSide')],1),_c('div',{staticClass:"admin-layout-main"},[_c('AdminContent')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }